import { render, staticRenderFns } from "./commonDownloadGuide.vue?vue&type=template&id=6f77d66e&scoped=true"
import script from "./commonDownloadGuide.vue?vue&type=script&lang=js"
export * from "./commonDownloadGuide.vue?vue&type=script&lang=js"
import style0 from "./commonDownloadGuide.vue?vue&type=style&index=0&id=6f77d66e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77d66e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f77d66e')) {
      api.createRecord('6f77d66e', component.options)
    } else {
      api.reload('6f77d66e', component.options)
    }
    module.hot.accept("./commonDownloadGuide.vue?vue&type=template&id=6f77d66e&scoped=true", function () {
      api.rerender('6f77d66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonDownloadGuide.vue"
export default component.exports